import type { Person } from "../types";

/** The sample studio's team. Fictional people; Asha Rao is the demo Owner (`?dev-session=asha`). */
export const PEOPLE: readonly Person[] = [
  {
    id: "p-asha",
    name: "Asha Rao",
    initials: "AR",
    colour: 1,
    title: "Principal architect",
    email: "asha@northlight.example",
  },
  {
    id: "p-rohan",
    name: "Rohan Mehta",
    initials: "RM",
    colour: 2,
    title: "Senior architect",
    email: "rohan@northlight.example",
  },
  {
    id: "p-meera",
    name: "Meera Iyer",
    initials: "MI",
    colour: 3,
    title: "Interior designer",
    email: "meera@northlight.example",
  },
  {
    id: "p-kabir",
    name: "Kabir Shah",
    initials: "KS",
    colour: 4,
    title: "Architect",
    email: "kabir@northlight.example",
  },
  {
    id: "p-priya",
    name: "Priya Nair",
    initials: "PN",
    colour: 5,
    title: "Project architect",
    email: "priya@northlight.example",
  },
  {
    id: "p-arjun",
    name: "Arjun Desai",
    initials: "AD",
    colour: 6,
    title: "Landscape architect",
    email: "arjun@northlight.example",
  },
  {
    id: "p-neha",
    name: "Neha Kulkarni",
    initials: "NK",
    colour: 1,
    title: "Urban designer",
    email: "neha@northlight.example",
  },
  {
    id: "p-vikram",
    name: "Vikram Singh",
    initials: "VS",
    colour: 2,
    title: "BIM coordinator",
    email: "vikram@northlight.example",
  },
];

/** People of the second demo organisation, Laterite Collective; Asha Rao is also a member there. */
export const LATERITE_PEOPLE: readonly Person[] = [
  {
    id: "p-farah",
    name: "Farah Siddiqui",
    initials: "FS",
    colour: 4,
    title: "Founding partner",
    email: "farah@laterite.example",
  },
  {
    id: "p-joseph",
    name: "Joseph Mathew",
    initials: "JM",
    colour: 5,
    title: "Conservation architect",
    email: "joseph@laterite.example",
  },
];

/** Asha Rao, the demo Owner of Northlight Studio. */
export const ME_ID = "p-asha";
